import color from 'color';

export const uiPrimaryUX = color('#28a8ea');
export const uiPrimaryRed = color('#c1121f');
export const uiPrimaryOrange = color('#ff6000');
export const uiPrimaryGreen = color('#008000');
export const uiPrimaryFont = color('#333');
export const uiPrimaryInvertFont = color('#eee');
